import React from "react";
import { BackendUserRole } from "./HomeLandingModel";

function roleLabel(role: BackendUserRole): string {
  // Keep values aligned with backend enum.
  return role;
}

export default function RoleChip({ role }: { role: BackendUserRole }) {
  return (
    <span className={`homeLandingRoleChip homeLandingRoleChip--${role}`}>
      {roleLabel(role)}
    </span>
  );
}

